<template>
  <v-breadcrumbs v-if="useBreadCrumbs"  divider=">" :items="this.breadcrumbs">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item :to="item.to" :exact="item.exact" :disabled="item.disabled">
          <span>{{ $t(item.text) }}</span>
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
</template>

<script>
export default {
  computed: {
    breadcrumbs() {
      let breadCrumbs = [];
      const currentRouteInfo = this.$route;
      if (this.useBreadCrumbs) {
        this.makeBreadCrumbs(breadCrumbs, currentRouteInfo);
      }
      return breadCrumbs.reverse();
    },
  },
  data() {
    return {
      useBreadCrumbs: {
        type: Boolean,
        default: false
      }
    }
  },
  methods: {
    makeBreadCrumbs(breadCrumbs, routeInfo) {
      // 1. 우선 현재 페이지 저장
      this.setBreadCrumb(breadCrumbs, routeInfo);
      // TODO 현재 parent 존재 여부
      if (routeInfo.meta.parent) {
        // 존재하면 상위 페이지 추가
        const upRouterInfo = this.$router.resolve({
          name: routeInfo.meta.parent,
        });
        this.makeBreadCrumbs(breadCrumbs, upRouterInfo.route);
      }
    },
    setBreadCrumb(breadCrumbs, routeInfo) {
      // breadcrumbs값 설정 메소드
      breadCrumbs.push({
        text: routeInfo.meta.title,
        exact: true,
        to: routeInfo.path,
      });
    },
  },
};
</script>

<style>
</style>